import { render, staticRenderFns } from "./IFrameVideoPlayer.vue?vue&type=template&id=68d11a3f&scoped=true"
import script from "./IFrameVideoPlayer.vue?vue&type=script&lang=js"
export * from "./IFrameVideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./IFrameVideoPlayer.vue?vue&type=style&index=0&id=68d11a3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d11a3f",
  null
  
)

export default component.exports